import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch, apiFetch, apiRemove } from '../modules/utility';

const apiBase = 'location';
//const item = 'location';
const idsField = 'locationIds';

const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};

const get = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const add = ({params, callback = _.noop }) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : idsField,
			params,
			dispatch,
			callback,
		});
	};
};

const update = ({params, callback = _.noop }) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};
const remove = ({locationId, callback = _.noop }) => {
	return dispatch => {
		apiRemove({
			base: apiBase,
			dispatch,
			id: locationId,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	//- Get a single location and the list of locations
	const locationId = (ownProps.locationId)
		? ownProps.locationId
		: _.get(ownProps, ['match', 'params', 'locationId']);
	const location = _.get(state.maps, ['location', locationId]);

	let locations = [];
	if (state.lists.locationIds) {
		locations = _.map(state.lists.locationIds, id => state.maps.location[id]);
	}

	return {
		location,
		locations,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getLocation : get,
	addLocation : add,
	removeLocation: remove,
	updateLocation : update,
	searchLocations : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
